import React, { Component } from 'react';
import { Route, Link, Switch, BrowserRouter as Router } from 'react-router-dom'
import Home  from '../pages/Home'
import {Knowledge} from '../pages/Knowledge'
import {FAQ} from '../pages/FAQ'
import Answers from '../pages/Answers'
import CreateTicket from '../pages/CreateTicket'
import Chat from '../pages/Chatpage'
import logo from '../zigloi.png'
export default class Header extends Component {


    render() {
        return (

            <header class="header-section">
        <div class="container">
            <div class="header-wrapper">
                <div class="logo-area">
                    <div class="logo">
                        <a href="">
                            <img src={logo} alt="logo" width="10px"/>
                        </a>
                    </div>
                    <div class="support">
                        <a href="#/changelog">Changelogs</a>
                    </div>
                </div>
                <ul class="menu">
                    <li>
                        <a href="/">Home</a>
                    </li>
                    {/* <li>
                        <a href="#/changelog">Changelogs</a>
                       
                    </li> */}
                    <li>
                        <a href="#/knowledge">Knowledge Base</a>
                       
                    </li>
                    <li>
                        <a href="#/faq">FAQ</a>
                       
                    </li>
                    <li>
                        <a href="#/contact">Contact Us</a>
                       
                    </li>
                  
                    <li class="d-md-none text-center">
                        <a href="#/customertickets" class="m-0 header-button">Submit a Ticket</a>
                    </li>
                </ul>
                <div class="header-bar d-lg-none">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="header-right">
                    <a href="#/customerticket" class="header-button d-none d-md-inline-block">Submit a Ticket</a>
                </div>
            </div>
        </div>


    </header>
            

           
        )
    }

}

/*


                        //     <Link class="nav-link-block top-nav-link w-inline-block" to="/">
                        //         <div class="nav-link-icon"></div>
                        //         <div class="nav-link-title ">Home</div>
                        //     </Link>
                        //     <Link class="nav-link-block top-nav-link w-inline-block" to="/knowledge">
                        //         <div class="nav-link-icon"></div>
                        //         <div class="nav-link-title">Knowledge Base</div>
                        //     </Link>
                            
                        //      <Link to="#">About</Link> 
                        //     <Link class="nav-link-block top-nav-link w-inline-block" to="/faq">
                        //         <div class="nav-link-icon"></div>
                        //         <div class="nav-link-title">FAQ</div>
                        //     </Link>

                        //     <Link class="nav-link-block top-nav-link w-inline-block" to="/customerticket">
                        //         <div class="nav-link-icon"></div>
                        //         <div class="nav-link-title">Open New Ticket</div>
                        //     </Link>
                        // </nav>
                     

            /* <script type="text/javascript">
        var Tawk_API = Tawk_API || {},
            Tawk_LoadStart = new Date();
        (function() {
            var s1 = document.createElement("script"),
                s0 = document.getElementsByTagName("script")[0];
            s1.async = true;
            s1.src = 'https://embed.tawk.to/5c6a726177e0730ce04371b9/default';
            s1.charset = 'UTF-8';
            s1.setAttribute('crossorigin', '*');
            s0.parentNode.insertBefore(s1, s0);
        })();
        </script> */

         
          